import * as Yup from 'yup';

import { IStatusColors } from 'components/Status';

import {
  WarehouseStatuses,
  DeliverooSiteStatus,
  IStoreDeliverooDetails,
  IDeliverooSiteSettings,
  JahezSiteStatus,
  AreaStatuses
} from './types';
export { EP_STORES_LIST, EP_STORES_GET_BY_ID, EP_STORES_UPDATE } from 'modules/endpoints';

export const WarehouseStatusDetails: { [key in WarehouseStatuses]: { label: string; color: IStatusColors } } = {
  [WarehouseStatuses.Active]: { label: 'Active', color: 'success' },
  [WarehouseStatuses.Busy]: { label: 'Busy', color: 'warning' },
  [WarehouseStatuses.Inactive]: { label: 'Inactive', color: 'error' }
};

export const AreaStatusDetails: { [key in AreaStatuses]: { label: string; color: IStatusColors } } = {
  [AreaStatuses.Active]: { label: 'Active', color: 'success' },
  [AreaStatuses.Busy]: { label: 'Busy', color: 'warning' },
  [AreaStatuses.Inactive]: { label: 'Inactive', color: 'error' },
  [AreaStatuses.AutoBusy]: { label: 'Auto Busy', color: 'warning' }
};

export const DeliverooSiteStatusDetails: { [key in DeliverooSiteStatus]: { label: string; color: IStatusColors } } = {
  [DeliverooSiteStatus.Open]: { label: 'Open', color: 'success' },
  [DeliverooSiteStatus.Closed]: { label: 'Closed', color: 'error' },
  [DeliverooSiteStatus.ReadyToOpen]: { label: 'Ready to open', color: 'warning' }
};

export const JahezSiteStatusDetails: { [key in JahezSiteStatus]: { label: string; color: IStatusColors } } = {
  [JahezSiteStatus.Open]: { label: 'Open', color: 'success' },
  [JahezSiteStatus.Closed]: { label: 'Closed', color: 'error' }
};

export const WarehouseUpdateScheme = Yup.object().shape({
  etaBufferTime: Yup.number().required('Start time is required').moreThan(-1),
  serviceHoursStartTime: Yup.string().required('Start time is required'),
  serviceHoursEndTime: Yup.string().required('End time is required'),
  busyMessageEnglish: Yup.string().when('status', {
    is: WarehouseStatuses.Busy,
    then: (schema) => schema.required('English Busy Message is required')
  }),
  busyMessageArabic: Yup.string().when('status', {
    is: WarehouseStatuses.Busy,
    then: (schema) => schema.required('Arabic Busy Message is required')
  }),

  delayWarningMessageAr: Yup.string().when('delayWarningMessageEn', {
    is: (delayWarningMessageEn: string) => !!delayWarningMessageEn && delayWarningMessageEn.length > 0,
    then: (schema) => schema.required('Arabic delay Message is required')
  })
});

const timeRangeSchema = Yup.object().shape({
  id: Yup.string().required(),
  startTime: Yup.string().required('Start time is required'),
  endTime: Yup.string().required('End time is required')
});

const serviceHoursDaySchema = Yup.object().shape({
  enabled: Yup.boolean().required(),
  timeRanges: Yup.array()
    .of(timeRangeSchema)
    .when('enabled', {
      is: true,
      then: (schema) => schema.min(1, 'At least one time range is required when day is enabled')
    })
});

const serviceHoursSchema = Yup.object().shape({
  monday: serviceHoursDaySchema,
  tuesday: serviceHoursDaySchema,
  wednesday: serviceHoursDaySchema,
  thursday: serviceHoursDaySchema,
  friday: serviceHoursDaySchema,
  saturday: serviceHoursDaySchema,
  sunday: serviceHoursDaySchema
});

export const DeliverooSettingsUpdateScheme = Yup.object().shape({
  id: Yup.string().required(),
  deliverooSiteId: Yup.string().nullable(),
  deliverooSiteStatus: Yup.number()
    .nullable()
    .when('deliverooSiteId', {
      is: (deliverooSiteId: string | null) => !!deliverooSiteId && deliverooSiteId.length > 0,
      then: (schema) => schema.required('Status is required')
    }),
  deliverooServiceHours: serviceHoursSchema.when('deliverooSiteId', {
    is: (deliverooSiteId: string | null) => !!deliverooSiteId && deliverooSiteId.length > 0,
    then: (schema) => schema.required('Service hours are required')
  })
});

export const DeliverooSiteScheme = Yup.object().shape({
  deliverooSiteId: Yup.string().nullable()
});

export const DelivrooStoreDetailsToSiteSettings = (storeDetails: IStoreDeliverooDetails): IDeliverooSiteSettings => ({
  id: storeDetails.id,
  deliverooSiteId: storeDetails.deliverooSiteId
});
